import { InboxService } from 'src/app/services/InboxService.service';
import { KeyValue } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.less']
})
export class ActivityComponent implements OnInit {
  activityFrom:FormGroup;
   activityAction:{[key:string]:string} = {
    'C':'phone call',
    'M':'Meeting',
    'T':'Task',
    'E':'Note',
    'P':'Campaign',
    'N':'Other'
  };
  priority:{[key:number]:string}={
    0:'Low',
    1:'Normal',
    2:'High'
  };
  YesNO:{[key:string]:string}={
    'Y':'Yes',
    'N':'No'
  }
  @Input() code:string;
  constructor(
    private inboxService:InboxService
  ) { }

  ngOnInit() {
    this.FormINit();
    console.log(this.activityFrom.value);
    console.log(this.activityAction);

  }

  onSubmit(){
  }


  getActivityDetails(){
    this.inboxService.getActivityById(this.code).subscribe(data=>{
      let activity=data.rowsArray[0];
      this.activityFrom.get('ClgCode').setValue(activity.ClgCode);
      this.activityFrom.get('Action').setValue(activity.Action);
      this.activityFrom.get('CardCode').setValue(activity.CardCode);
      this.activityFrom.get('CntctSbjct').setValue(activity.CntctSbjct);
      this.activityFrom.get('CardName').setValue(activity.CardName);
      this.activityFrom.get('ContactPer').setValue(activity.ContactPer);
      this.activityFrom.get('Tel').setValue(activity.Tel);
      this.activityFrom.get('AttendUser').setValue(activity.AttendUser);
      this.activityFrom.get('AssignedBy').setValue(activity.AssignedBy);
      this.activityFrom.get('U_ITM_BWEB_READ').setValue(activity.U_ITM_BWEB_READ);
      this.activityFrom.get('Details').setValue(activity.Details);
      this.activityFrom.get('Recontact').setValue(activity.Recontact);
      this.activityFrom.get('BeginTime').setValue(activity.BeginTime);
      this.activityFrom.get('endDate').setValue(activity.endDate);
      this.activityFrom.get('ENDTime').setValue(activity.ENDTime);
      this.activityFrom.get('Priority').setValue(activity.Priority);
      this.activityFrom.get('Closed').setValue(activity.Closed);
      this.activityFrom.get('CloseDate').setValue(activity.CloseDate);
      this.activityFrom.get('U_ITM_CUSTOM_STATUS').setValue(activity.U_ITM_CUSTOM_STATUS);
      this.activityFrom.get('inactive').setValue(activity.inactive);
      this.activityFrom.get('Reminder').setValue(activity.Reminder);
      this.activityFrom.get('RemQty').setValue(activity.RemQty);
      this.activityFrom.get('RemType').setValue(activity.RemType);
      this.activityFrom.get('Notes').setValue(activity.Notes);
      this.activityFrom.get('DocType').setValue(activity.DocType);
      this.activityFrom.get('DocNum').setValue(activity.DocNum);
      console.log(data);

    })
  }

  FormINit(){
    this.activityFrom=new FormGroup({
      ClgCode:new FormControl({value: null, disabled: true}),
      Action:new FormControl(null),
      CardCode:new FormControl(null),
      CntctSbjct:new FormControl(null),
      CardName:new FormControl(null),
      ContactPer:new FormControl(null),
      Tel:new FormControl(null),
      AttendUser:new FormControl(null),
      AssignedBy:new FormControl({value:null,disabled:true}),
      U_ITM_BWEB_READ:new FormControl({value:null,disabled:true}),
      Details:new FormControl(null),
      Recontact:new FormControl(null),
      BeginTime:new FormControl(null),
      endDate:new FormControl(null),
      ENDTime:new FormControl(null),
      Priority:new FormControl(null),
      Closed:new FormControl(null),
      CloseDate:new FormControl(null),
      U_ITM_CUSTOM_STATUS:new FormControl(null),
      inactive:new FormControl(null),
      Reminder:new FormControl(null),
      RemQty:new FormControl(null),
      RemType:new FormControl(null),
      Notes:new FormControl(null),
      DocType:new FormControl(null),
      DocNum:new FormControl(null)
    })
    this.getActivityDetails();
  }
}
